// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const VhostBindingSourceSchema = z.enum(['DNS','CLOUD_ALIAS','TLS_SAN','HTTP_PROBE','VHOST_ENUM'] as const);

export type VhostBindingSourceType = `${z.infer<typeof VhostBindingSourceSchema>}`

export default VhostBindingSourceSchema;
